module.exports = __webpack_public_path__ + "static/01_img_9325-ff6f935c67020012d114599a07b32bf6.webp";